export default Object.freeze([
	{
		barcodeType: 'UPC',
	},
	{
		barcodeType: 'ASIN',
	},
	{
		barcodeType: 'EAN',
	},
	{
		barcodeType: 'ISBN',
	},
]);
